<template>
  <div id="setting" class="position-absolute">
    <i
      class="iconfont icon-close text-color-white position-absolute cur-pointer close-button"
      @click="closeSetting"
    ></i>
    <el-tabs v-model="activeName" class="h-100" @tab-click="settingActiveChange">
      <el-tab-pane label="显示设置" name="displaySetting">
        <el-card
          class="w-100 m-t-5 display-set-card"
          :body-style="{ width: '100%', padding: '5px 10px' }"
        >
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">点选高亮 :</div>
            </el-col>
            <el-col :span="4" class="d-flex flex-align-center">
              <el-switch
                v-model="pickupHighlight"
                @change="(e) => switchChange(e, 'pickUp.highlight')"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-col>
            <el-col :span="12" class="d-flex flex-align-center">
              <el-color-picker
                v-model="pickupHighlightColor"
                size="small"
                @change="
                  (e) => {
                    colorPickerChange(e, 'pickup.color', false, 'string')
                  }
                "
                show-alpha
                color-format="rgb"
              ></el-color-picker>
              <el-input
                v-model="pickupHighlightColor"
                @change="
                  (e) => {
                    colorPickerChange(e, 'pickup.color', false, 'string')
                  }
                "
                class="color-input"
                placeholder=""
                size="mini"
              ></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">包围盒 :</div>
            </el-col>
            <el-col :span="4" class="d-flex flex-align-center">
              <el-switch
                v-model="showSiegeBox"
                @change="(e) => switchChange(e, 'show.select.box')"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-col>
            <el-col :span="12" class="d-flex flex-align-center"></el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">点选轮廓 :</div>
            </el-col>
            <el-col :span="4" class="d-flex flex-align-center">
              <el-switch
                @change="(e) => switchChange(e, 'postprocess.outline')"
                v-model="showPickupOutline"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-col>
            <el-col :span="12" class="d-flex flex-align-center">
              <el-color-picker
                v-model="pickupOutlineColor"
                size="small"
                show-alpha
                @change="
                  (e) => {
                    colorPickerChange(e, 'pickup.edgeColor', true, 'string')
                  }
                "
                color-format="rgb"
              ></el-color-picker>
              <el-input
                v-model="pickupOutlineColor"
                class="color-input"
                placeholder=""
                @change="
                  (e) => {
                    colorPickerChange(e, 'pickup.edgeColor', true, 'string')
                  }
                "
                size="mini"
              ></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">模型线框 :</div>
            </el-col>
            <el-col :span="4" class="d-flex flex-align-center">
              <el-switch
                @change="(e) => switchChange(e, 'render.edge')"
                v-model="showModelBorder"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-col>
            <el-col :span="12" class="d-flex flex-align-center"> </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">点选背景虚化 :</div>
            </el-col>
            <el-col :span="9" class="d-flex flex-align-center">
              <el-slider
                v-model="pickupBackgroundVirtual"
                :min="0"
                :max="1"
                class="w-100"
                :step="0.01"
                @input="
                  (e) => {
                    sliderChange(e, 'color.pickup.bkAlpha', 'float')
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="pickupBackgroundVirtual"
                class="color-input"
                placeholder=""
                size="mini"
                @change="
                  (e) => {
                    sliderChange(e, 'color.pickup.bkAlpha', 'float')
                  }
                "
                controls-position="right"
                :min="0"
                :max="1"
                :step="0.01"
              ></el-input-number>
            </el-col>
          </el-row>
        </el-card>
        <el-card
          class="w-100 m-t-5 display-set-card"
          :body-style="{ width: '100%', padding: '5px 10px' }"
        >
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">旋转速度 :</div>
            </el-col>
            <el-col :span="9" class="d-flex flex-align-center">
              <el-slider
                v-model="minimumRotateSpeed"
                :min="0"
                :max="1"
                class="w-100"
                :step="0.01"
                @input="
                  (e) => {
                    sliderChange(e, 'mouse.rotate.speed', 'float')
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="minimumRotateSpeed"
                class="color-input"
                placeholder=""
                size="mini"
                controls-position="right"
                :min="0"
                :max="1"
                :step="0.01"
                @change="
                  (e) => {
                    sliderChange(e, 'mouse.rotate.speed', 'float')
                  }
                "
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">缩放速度 :</div>
            </el-col>
            <el-col :span="9" class="d-flex flex-align-center">
              <el-slider
                v-model="minimumScaleSpeed"
                :min="0"
                :max="1"
                class="w-100"
                :step="0.01"
                @input="
                  (e) => {
                    sliderChange(e, 'mouse.scale.speed', 'float')
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="minimumScaleSpeed"
                class="color-input"
                placeholder=""
                size="mini"
                controls-position="right"
                :min="0"
                :max="1"
                :step="0.01"
                @change="
                  (e) => {
                    sliderChange(e, 'mouse.scale.speed', 'float')
                  }
                "
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">最小可见像素 :</div>
            </el-col>
            <el-col :span="9" class="d-flex flex-align-center">
              <el-slider
                v-model="minimumVisiblePixel"
                :min="1"
                :max="100"
                class="w-100"
                :step="1"
                @input="
                  (e) => {
                    sliderChange(e, 'MinPixelCount', 'int')
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="minimumVisiblePixel"
                class="color-input"
                placeholder=""
                size="mini"
                controls-position="right"
                :min="1"
                :max="100"
                :step="1"
                @change="
                  (e) => {
                    sliderChange(e, 'MinPixelCount', 'int')
                  }
                "
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">环境光阻挡 :</div>
            </el-col>
            <el-col :span="4" class="d-flex flex-align-center">
              <el-switch
                @change="(e) => switchChange(e, 'postprocess.ssao')"
                v-model="ambientLightBlock"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-col>
            <el-col :span="12" class="d-flex flex-align-center"> </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-10">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">全局光源 :</div>
            </el-col>
            <el-col :span="16" class="d-flex flex-align-center">
              <el-select
                v-model="globalLightSource"
                popper-class="document_select-popper"
                class="w-100"
                size="mini"
                placeholder="--请选择--"
                @change="
                  (e) => {
                    selectChange(e, 'context.shaderIndex', 'int')
                  }
                "
              >
                <el-option
                  v-for="item in globalLightSourceOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">环境光补偿 :</div>
            </el-col>
            <el-col :span="9" class="d-flex flex-align-center">
              <el-slider
                v-model="ambientLightRestitution"
                :min="0"
                :max="1"
                class="w-100"
                :step="0.01"
                @input="
                  (e) => {
                    sliderChange(e, 'ambientIndenty', 'float')
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="ambientLightRestitution"
                class="color-input"
                placeholder=""
                size="mini"
                @change="
                  (e) => {
                    sliderChange(e, 'ambientIndenty', 'float')
                  }
                "
                controls-position="right"
                :min="0"
                :max="1"
                :step="0.01"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">全局光源强度 :</div>
            </el-col>
            <el-col :span="9" class="d-flex flex-align-center">
              <el-slider
                v-model="globalLightSourceStrength"
                :min="0"
                :max="1"
                class="w-100"
                @input="
                  (e) => {
                    sliderChange(e, 'diffuseIntensity', 'float')
                  }
                "
                :step="0.01"
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="globalLightSourceStrength"
                class="color-input"
                placeholder=""
                size="mini"
                controls-position="right"
                @input="
                  (e) => {
                    sliderChange(e, 'diffuseIntensity', 'float')
                  }
                "
                :min="0"
                :max="1"
                :step="0.01"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">高光强度 :</div>
            </el-col>
            <el-col :span="9" class="d-flex flex-align-center">
              <el-slider
                v-model="highLightStrength"
                :min="0"
                :max="1.5"
                class="w-100"
                @input="
                  (e) => {
                    sliderChange(e, 'specularIntensity', 'float')
                  }
                "
                :step="0.01"
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="highLightStrength"
                class="color-input"
                placeholder=""
                size="mini"
                controls-position="right"
                @input="
                  (e) => {
                    sliderChange(e, 'specularIntensity', 'float')
                  }
                "
                :min="0"
                :max="1.5"
                :step="0.01"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">摄像机最小裁剪面 :</div>
            </el-col>
            <el-col :span="9" class="d-flex flex-align-center">
              <el-slider
                v-model="minimumCuttingSurface"
                :min="0"
                :max="1"
                class="w-100"
                @input="
                  (e) => {
                    sliderChange(e, 'camera.minClip', 'double')
                  }
                "
                :step="0.001"
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="minimumCuttingSurface"
                class="color-input"
                placeholder=""
                size="mini"
                controls-position="right"
                @change="
                  (e) => {
                    sliderChange(e, 'camera.minClip', 'double')
                  }
                "
                :min="0"
                :max="1"
                :step="0.001"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-10">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">背面裁剪 :</div>
            </el-col>
            <el-col :span="16" class="d-flex flex-align-center">
              <el-select
                v-model="backCutting"
                popper-class="document_select-popper"
                class="w-100"
                size="mini"
                placeholder="--请选择--"
                @change="
                  (e) => {
                    selectChange(e, 'cullface_mode', 'stringList')
                  }
                "
              >
                <el-option
                  v-for="item in backCuttingOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-10">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">天空盒 :</div>
            </el-col>
            <el-col :span="16" class="d-flex flex-align-center">
              <el-select
                v-model="skyBox"
                popper-class="document_select-popper"
                class="w-100"
                size="mini"
                placeholder="--请选择--"
                @change="
                  (e) => {
                    selectChange(e, 'skybox.list', 'stringList')
                  }
                "
              >
                <el-option
                  v-for="item in skyBoxOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-card>
        <!-- 锚点信息框选择 -->
        <el-card
          class="w-100 m-t-5 display-set-card"
          :body-style="{ width: '100%', padding: '5px 10px' }"
        >
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">锚点信息框 :</div>
            </el-col>
            <el-col :span="16" class="d-flex flex-align-center">
              <el-select
                v-model="anchorPointInfoFrame"
                popper-class="document_select-popper"
                class="w-100"
                size="mini"
                @change="
                  (e) => {
                    selectChange(e, 'anchorPointInfoFrame', 'string')
                  }
                "
                placeholder="--请选择--"
              >
                <el-option
                  v-for="item in anchorPointInfoFrameOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-card>
        <el-card
          class="w-100 m-t-5 display-set-card"
          :body-style="{ width: '100%', padding: '10px' }"
          v-if="$route.query.documentId"
        >
          <el-row :gutter="8" type="flex" align="middle">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">默认视角获取 :</div>
            </el-col>
            <el-col :span="16" class="d-flex flex-align-center">
              <el-button type="primary" size="mini" class="w-100" @click="setCurrentCameraPos"
                >获取当前视角为默认打开视角</el-button
              >
            </el-col>
          </el-row>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="漫游设置" name="roamingSetting">
        <el-card
          class="w-100 m-t-5 display-set-card"
          :body-style="{ width: '100%', padding: '10px' }"
        >
          <div class="w-100 b fz-14 text-color-white">虚拟人物形象</div>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">人物安全帽 :</div>
            </el-col>
            <el-col :span="16" class="d-flex flex-align-center">
              <el-select
                v-model="safetyHelmet"
                popper-class="document_select-popper"
                class="w-100"
                size="mini"
                @change="(e) => changeFigureMolding(e, 'setAvatarCapSkin')"
                placeholder="--请选择--"
              >
                <el-option
                  v-for="item in safetyHelmetOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  class="d-flex flex-align-center"
                >
                  <div
                    class="select-option-item m-l-10"
                    :style="{ backgroundColor: item.color }"
                  ></div>
                  <span class="m-l-10">{{ item.label }}</span>
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">人物工作服 :</div>
            </el-col>
            <el-col :span="16" class="d-flex flex-align-center">
              <el-select
                v-model="workingClothes"
                popper-class="document_select-popper"
                class="w-100"
                size="mini"
                placeholder="--请选择--"
                @change="(e) => changeFigureMolding(e, 'setAvatarBodySkin')"
              >
                <el-option
                  v-for="item in workingClothesOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  class="d-flex flex-align-center"
                >
                  <div
                    class="select-option-item m-l-10"
                    :style="{ backgroundColor: item.color }"
                  ></div>
                  <span class="m-l-10">{{ item.label }}</span>
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-card>
        <el-card
          class="w-100 m-t-5 display-set-card"
          :body-style="{ width: '100%', padding: '10px' }"
        >
          <!-- <div class="w-100 b fz-14 text-color-white">虚拟人物形象</div> -->
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="8">
              <div class="w-100 setting-text-lable fz-12">人物移动速度 :</div>
            </el-col>
            <el-col :span="9" class="d-flex flex-align-center">
              <el-slider
                v-model="mouseMoveSpeed"
                :min="1"
                :max="10"
                class="w-100"
                :step="1"
                @input="
                  (e) => {
                    changeWalkSpeed(e)
                  }
                "
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="mouseMoveSpeed"
                class="color-input"
                placeholder=""
                size="mini"
                @change="
                  (e) => {
                    changeWalkSpeed(e)
                  }
                "
                controls-position="right"
                :min="1"
                :max="10"
                :step="1"
              ></el-input-number>
            </el-col>
          </el-row>
        </el-card>
        <el-card
          class="w-100 m-t-5 display-set-card"
          :body-style="{ width: '100%', padding: '10px' }"
        >
          <div class="w-100 b fz-14 text-color-white">快捷键设置</div>
          <el-row :gutter="8" class="m-t-5 keystroke-set">
            <el-col
              :span="12"
              class="d-flex flex-align-center m-t-10"
              v-for="item in shortCutKeySettings"
              :key="item.name"
            >
              <div class="w-100 setting-text-lable fz-12 m-r-5">{{ item.label }} :</div>
              <el-tooltip effect="dark" :content="item.value" placement="top" :open-delay="1000">
                <el-input
                  :value="item.value"
                  @focus="
                    (e) => {
                      keySetting(e, item, 1)
                    }
                  "
                  placeholder=""
                  size="mini"
                ></el-input>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-card>
        <!-- <el-card
          class="w-100 m-t-5 display-set-card"
          :body-style="{ width: '100%', padding: '10px' }"
        >
          <div class="w-100 b fz-14 text-color-white">人物移动速度</div>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="6">
              <div class="w-100 setting-text-lable fz-12">行走 :</div>
            </el-col>
            <el-col :span="11" class="d-flex flex-align-center">
              <el-slider
                v-model="walkingSpeed"
                :min="0"
                :max="100"
                class="w-100"
                :step="1"
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="walkingSpeed"
                class="color-input"
                placeholder=""
                size="mini"
                controls-position="right"
                :min="0"
                :max="100"
                :step="1"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="6">
              <div class="w-100 setting-text-lable fz-12">蹲下 :</div>
            </el-col>
            <el-col :span="11" class="d-flex flex-align-center">
              <el-slider
                v-model="squatMoveSpeed"
                :min="0"
                :max="100"
                class="w-100"
                :step="1"
              ></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="squatMoveSpeed"
                class="color-input"
                placeholder=""
                size="mini"
                controls-position="right"
                :min="0"
                :max="100"
                :step="1"
              ></el-input-number>
            </el-col>
          </el-row>
          <el-row :gutter="8" type="flex" align="middle" class="m-t-5">
            <el-col :span="6">
              <div class="w-100 setting-text-lable fz-12">奔跑 :</div>
            </el-col>
            <el-col :span="11" class="d-flex flex-align-center">
              <el-slider v-model="runSpeed" :min="0" :max="100" class="w-100" :step="1"></el-slider>
            </el-col>
            <el-col :span="7" class="d-flex flex-align-center">
              <el-input-number
                v-model="runSpeed"
                class="color-input"
                placeholder=""
                size="mini"
                controls-position="right"
                :min="0"
                :max="100"
                :step="1"
              ></el-input-number>
            </el-col>
          </el-row>
        </el-card> -->
      </el-tab-pane>
    </el-tabs>
    <div class="w-100 m-t-10 d-flex flex-align-center flex-row-end">
      <el-button size="mini" @click="closeSetting">取消</el-button>
      <el-button type="primary" size="mini" class="m-l-10" @click="saveSettings">保存</el-button>
    </div>
  </div>
</template>
<script>
import DocumentManagementService from '@/services/documentManagement'

export default {
  name: 'PlayerSetting',
  components: {},
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      activeName: 'displaySetting',
      pickupHighlight: true, // 点选高亮
      pickupHighlightColor: 'rgba(255,255,255,255)', // 点选高亮颜色
      showSiegeBox: true, // 包围盒
      showPickupOutline: true, // 点选轮廓
      pickupOutlineColor: 'rgba(255,255,255,255)', // 点选轮廓颜色
      showModelBorder: true, // 模型线框
      pickupBackgroundVirtual: 0, // 点选背景虚化
      mouseMoveSpeed: 1, // 人物移动速度
      ambientLightBlock: true, // 环境光阻挡
      ambientLightRestitution: 0, // 环境光补偿
      globalLightSource: '', // 全局光源
      // 全局光源配置
      globalLightSourceOptions: [
        { value: 0, label: '默认' },
        { value: 1, label: '预设单灯' },
        { value: 2, label: '预设双灯' },
        { value: 3, label: '预设三灯' },
      ],
      globalLightSourceStrength: 0, // 全局光源强度
      minimumCuttingSurface: 0, // 摄像机最小裁剪面
      highLightStrength: 0, // 高光强度
      minimumVisiblePixel: 0, // 最小可见像素
      minimumRotateSpeed: 0, // 旋转速度
      minimumScaleSpeed: 0, // 缩放速度
      skyBox: '', // 天空盒
      skyBoxOptions: [],
      anchorPointInfoFrame: '', // 锚点信息框
      anchorPointInfoFrameOptions: [
        { value: 'null', label: '无' },
        { value: 'code', label: '对象编码' },
        { value: 'name', label: '对象名称' },
        { value: 'code+name', label: '编码+名称' },
      ],
      safetyHelmet: '', // 人物安全帽
      safetyHelmetOptions: [
        { value: 'helmet_yellow.jpg', label: '黄色', color: '#ffff00' },
        { value: 'helmet_bule.jpg', label: '蓝色', color: '#0000ff' },
        { value: 'helmet_white.jpg', label: '白色', color: '#ffffff' },
        { value: 'helmet_orange.jpg', label: '橙色', color: '#ffa500' },
        { value: 'helmet_red.jpg', label: '红色', color: '#ff0000' },
      ],
      backCutting: '', // 背面裁剪
      backCuttingOptions: [
        { value: 'none', label: '未设置' },
        { value: 'front', label: '显示正面' },
        { value: 'back', label: '显示背面' },
        { value: 'frontAndBack', label: '双面绘制' },
      ],
      workingClothes: '', // 人物工作服
      workingClothesOptions: [
        { value: 'GongRen_red.jpg', label: '红色', color: '#ff0000' },
        { value: 'GongRen_white.jpg', label: '白色', color: '#ffffff' },
        { value: 'GongRen_yellow.jpg', label: '黄色', color: '#ffff00' },
        { value: 'GongRen_blue.jpg', label: '蓝色', color: '#0000ff' },
        { value: 'GongRen_gray.jpg', label: '浅灰色', color: '#dcdfe6' },
      ],
      // 人物形象设置
      figureSkin: {
        avatarCapSkin: '',
        avatarBodySkin: '',
      },
      roamingAngle: 'firstAngle', // 漫游视角
      shortCutKeySettings: [
        {
          label: '前进',
          name: '前进',
          value: 'W',
        },
        {
          label: '后退',
          name: '后退',
          value: 'S',
        },
        {
          label: '向左移动',
          name: '向左移动',
          value: 'A',
        },
        {
          label: '向右移动',
          name: '向右移动',
          value: 'D',
        },
        {
          label: '向上仰视',
          name: '向上仰视',
          value: 'I',
        },
        {
          label: '向下俯视',
          name: '向下俯视',
          value: 'K',
        },
        {
          label: '左转',
          name: '左转',
          value: 'J',
        },
        {
          label: '右转',
          name: '右转',
          value: 'L',
        },
        {
          label: '跳起',
          name: '跳起',
          value: 'Space',
        },
        {
          label: '无重力跳',
          name: '无重力跳',
          value: 'Z+Space',
        },
        {
          label: '奔跑',
          name: '奔跑',
          value: 'Shift',
        },
        {
          label: '蹲下',
          name: '蹲下',
          value: 'Ctrl',
        },
        {
          label: '垂直向上',
          name: '垂直向上移动',
          value: 'Q',
        },
        {
          label: '垂直向下',
          name: '垂直向下移动',
          value: 'E',
        },
        {
          label: '穿墙',
          name: '开启/关闭人物穿墙',
          value: 'C',
        },
        {
          label: '开/关失重',
          name: '开启/关闭人物飞行模式',
          value: 'Comma',
        },
        // {
        //   label: '加速',
        //   name: '增加漫游前进速度',
        //   value: '+',
        // },
        // {
        //   label: '减速',
        //   name: '减少漫游前进速度',
        //   value: '-',
        // },
      ],
      walkingSpeed: 0, // 行走速度
      squatMoveSpeed: 0, // 蹲下移动速度
      runSpeed: 0, // 奔跑速度
      sliderChangeTimerOut: null, // 滑动条防抖
      asciiToKeyCode: [
        { code: 48, key: 'Zero', eventKey: '0' },
        { code: 49, key: 'One', eventKey: '1' },
        { code: 50, key: 'Two', eventKey: '2' },
        { code: 51, key: 'Three', eventKey: '3' },
        { code: 52, key: 'Four', eventKey: '4' },
        { code: 53, key: 'Five', eventKey: '5' },
        { code: 54, key: 'Six', eventKey: '6' },
        { code: 55, key: 'Seven', eventKey: '7' },
        { code: 56, key: 'Eight', eventKey: '8' },
        { code: 57, key: 'Nine', eventKey: '9' },
        { code: 65, key: 'A', eventKey: 'A' },
        { code: 66, key: 'B', eventKey: 'B' },
        { code: 67, key: 'C', eventKey: 'C' },
        { code: 68, key: 'D', eventKey: 'D' },
        { code: 69, key: 'E', eventKey: 'E' },
        { code: 70, key: 'F', eventKey: 'F' },
        { code: 71, key: 'G', eventKey: 'G' },
        { code: 72, key: 'H', eventKey: 'H' },
        { code: 73, key: 'I', eventKey: 'I' },
        { code: 74, key: 'J', eventKey: 'J' },
        { code: 75, key: 'K', eventKey: 'K' },
        { code: 76, key: 'L', eventKey: 'L' },
        { code: 77, key: 'M', eventKey: 'M' },
        { code: 78, key: 'N', eventKey: 'N' },
        { code: 79, key: 'O', eventKey: 'O' },
        { code: 80, key: 'P', eventKey: 'P' },
        { code: 81, key: 'Q', eventKey: 'Q' },
        { code: 82, key: 'R', eventKey: 'R' },
        { code: 83, key: 'S', eventKey: 'S' },
        { code: 84, key: 'T', eventKey: 'T' },
        { code: 85, key: 'U', eventKey: 'U' },
        { code: 86, key: 'V', eventKey: 'V' },
        { code: 87, key: 'W', eventKey: 'W' },
        { code: 88, key: 'X', eventKey: 'X' },
        { code: 89, key: 'Y', eventKey: 'Y' },
        { code: 90, key: 'Z', eventKey: 'Z' },
        { code: 38, key: 'ArrowUp', eventKey: 'ArrowUp' },
        { code: 40, key: 'ArrowDown', eventKey: 'ArrowDown' },
        { code: 37, key: 'ArrowLeft', eventKey: 'ArrowLeft' },
        { code: 39, key: 'ArrowRight', eventKey: 'ArrowRight' },
        { code: 36, key: 'Home', eventKey: 'Home' },
        { code: 35, key: 'End', eventKey: 'End' },

        { code: 34, key: 'PageDown', eventKey: 'PageDown' },
        { code: 33, key: 'PageUp', eventKey: 'PageUp' },
        { code: 45, key: 'Insert', eventKey: 'Insert' },
        { code: 46, key: 'Delete', eventKey: 'Delete' },

        { code: 112, key: 'F1', eventKey: 'F1' },
        { code: 113, key: 'F2', eventKey: 'F2' },
        { code: 114, key: 'F3', eventKey: 'F3' },
        { code: 115, key: 'F4', eventKey: 'F4' },
        { code: 116, key: 'F5', eventKey: 'F5' },
        { code: 117, key: 'F6', eventKey: 'F6' },
        { code: 118, key: 'F7', eventKey: 'F7' },
        { code: 119, key: 'F8', eventKey: 'F8' },
        { code: 120, key: 'F9', eventKey: 'F9' },
        { code: 121, key: 'F10', eventKey: 'F10' },
        { code: 122, key: 'F11', eventKey: 'F11' },
        { code: 123, key: 'F12', eventKey: 'F12' },

        { code: 27, key: 'Escape', eventKey: 'Escape' },
        { code: 13, key: 'Return', eventKey: 'Enter' },
        { code: 187, key: 'Add', eventKey: '+' },
        { code: 189, key: 'Subtract', eventKey: '-' },
        { code: 108, key: 'Divide', eventKey: '/' },
        { code: 106, key: 'Multiply', eventKey: '*' },
        { code: 111, key: 'Divide', eventKey: '/' },
        { code: 20, key: 'Capital', eventKey: 'Capital' },

        { code: 8, key: 'Backspace', eventKey: 'Backspace' },
        { code: 9, key: 'Tab', eventKey: 'Tab' },
        { code: 18, key: 'Alt', eventKey: 'Alt' },
        { code: 164, key: 'LeftAlt', eventKey: 'Alt' },
        { code: 165, key: 'RightAlt', eventKey: 'Alt' },
        { code: 91, key: 'LeftWindows', eventKey: 'Windows' },
        { code: 92, key: 'RightWindows', eventKey: 'Windows' },
        { code: 16, key: 'Shift', eventKey: 'Shift' },
        { code: 160, key: 'LeftShift', eventKey: 'Shift' },
        { code: 161, key: 'RightShift', eventKey: 'Shift' },
        { code: 17, key: 'Control', eventKey: 'Ctrl' },
        { code: 162, key: 'LeftControl', eventKey: 'Ctrl' },
        { code: 163, key: 'RightControl', eventKey: 'Ctrl' },

        { code: 188, key: 'Comma', eventKey: ',' },

        { code: 19, key: 'Pause', eventKey: 'Pause' },
        { code: 145, key: 'ScrollLock', eventKey: 'ScrollLock' },
        { code: 32, key: 'Space', eventKey: 'Space' },
        { code: 32, key: 'Capital', eventKey: 'Capital' },
        { code: 144, key: 'NumLock', eventKey: 'NumLock' },
        { code: 96, key: 'Numpad0', eventKey: 'Num0' },
        { code: 97, key: 'Numpad1', eventKey: 'Num1' },
        { code: 98, key: 'Numpad2', eventKey: 'Num2' },
        { code: 99, key: 'Numpad3', eventKey: 'Num3' },
        { code: 100, key: 'Numpad4', eventKey: 'Num4' },
        { code: 101, key: 'Numpad5', eventKey: 'Num5' },
        { code: 102, key: 'Numpad6', eventKey: 'Num6' },
        { code: 103, key: 'Numpad7', eventKey: 'Num7' },
        { code: 104, key: 'Numpad8', eventKey: 'Num8' },
        { code: 105, key: 'Numpad9', eventKey: 'Num9' },
        { code: 106, key: 'Decimal', eventKey: 'Decimal' },
      ],
      orignDisplaySettings: [], // 初始设置
      orignHotKeysSettings: {}, // 初始漫游设置
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  created() {
    this.getAllSetting()
  },
  beforeDestroy() {
    document.oncontextmenu = null
    document.onkeydown = null
  },
  methods: {
    // 保存设置
    async saveSettings() {
      this.$confirm('是否保存当前设置！', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      })
        .then(async () => {
          const displayRes = await this.player.Native.Settings.getAll()
          const roamingRes = await this.player.Native.Walking.getHotkeys()
          roamingRes.RoamingSpeed = await this.player.Native.Walking.avatarMoveSpeed()
          const jsonData = {
            Show: displayRes,
            RoamTrance: roamingRes,
            Skin: {
              avatarCapSkin: this.safetyHelmet,
              avatarBodySkin: this.workingClothes,
            },
          }
          const saveRes = await this.player.Native.Settings.saveJsonString(
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/settings.json`,
            JSON.stringify(jsonData)
          )
          if (saveRes) {
            this.$message.success('保存设置成功！')
            this.$emit('closeSetting')
          } else {
            this.$message.warning('保存设置失败！')
          }
        })
        .catch(() => {})
    },
    // 关闭设置
    async closeSetting() {
      const currentDisplaySettings = await this.player.Native.Settings.getAll()
      const isUpdateDisplay = _.every(this.orignDisplaySettings, (item) => {
        const currentItemSetting = _.find(currentDisplaySettings, (el) => {
          return el.name === item.name && el.type === item.type
        })
        return currentItemSetting && currentItemSetting.value === item.value
      })
      const currentRoamingSettings = await this.player.Native.Walking.getHotkeys()
      const currentKeys = Object.getOwnPropertyNames(currentRoamingSettings)
      const isUpdateRoaming = _.every(currentKeys, (item) => {
        console.log(currentRoamingSettings[item], this.orignHotKeysSettings[item])
        return (
          currentRoamingSettings[item][0] &&
          this.orignHotKeysSettings[item][0] &&
          currentRoamingSettings[item][0] === this.orignHotKeysSettings[item][0]
        )
      })
      if (
        !isUpdateDisplay ||
        !isUpdateRoaming ||
        this.safetyHelmet !== this.figureSkin.avatarCapSkin ||
        this.workingClothes !== this.figureSkin.avatarBodySkin
      ) {
        this.$confirm('是否保存当前设置！', '提示', {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
          type: 'warning',
          lockScroll: false,
        })
          .then(async () => {
            const displayRes = await this.player.Native.Settings.getAll()
            const roamingRes = await this.player.Native.Walking.getHotkeys()
            roamingRes.RoamingSpeed = await this.player.Native.Walking.avatarMoveSpeed()
            const jsonData = {
              Show: displayRes,
              RoamTrance: roamingRes,
              Skin: {
                avatarCapSkin: this.safetyHelmet,
                avatarBodySkin: this.workingClothes,
              },
            }
            const saveRes = await this.player.Native.Settings.saveJsonString(
              `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/settings.json`,
              JSON.stringify(jsonData)
            )
            if (saveRes) {
              this.$message.success('保存设置成功！')
              this.$emit('closeSetting')
            } else {
              this.$message.warning('保存设置失败！')
            }
          })
          .catch(async () => {
            _.forEach(this.orignDisplaySettings, (item) => {
              this.player.Native.Settings.set(item.name, item.type, item.value)
            })
            _.forIn(this.orignHotKeysSettings, (value, key) => {
              const settingKeys = _.reduce(
                value,
                (arr, item) => {
                  arr.push(item.split('+'))
                  return arr
                },
                []
              )
              this.player.Native.Walking.setHotkey(key, settingKeys)
            })
            const isExists = await this.player.Native.File.exists(
              `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/skin`
            )
            if (isExists) {
              this.player.Native.Walking.setAvatarBodySkin(
                `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${this.figureSkin.avatarBodySkin}`
              )
              this.player.Native.Walking.setAvatarCapSkin(
                `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${this.figureSkin.avatarCapSkin}`
              )
            }
            this.$emit('closeSetting')
          })
      } else {
        this.$emit('closeSetting')
      }
    },
    // 设置默认视角
    async setCurrentCameraPos() {
      if (this.$route.query.documentId) {
        const res = await DocumentManagementService.getDocumentEdite({
          id: this.$route.query.documentId,
        })
        if (res && res.code === 0 && res.data) {
          const paramsData = res.data
          const modelGenAttrTemIndex = _.findIndex(paramsData.templateAttrSetList, (item) => {
            return item.attributeTemplate.code === 'ModelGeneralAttribute'
          })
          console.log(modelGenAttrTemIndex)
          if (modelGenAttrTemIndex !== -1) {
            const cameraPostionIndex = _.findIndex(
              paramsData.templateAttrSetList[modelGenAttrTemIndex].attrValueList,
              ['fieldName', 'CameraPosition']
            )
            if (cameraPostionIndex !== -1) {
              const cameraPosValue = await this.player.Native.Camera.currentParam()
              paramsData.templateAttrSetList[modelGenAttrTemIndex].attrValueList[
                cameraPostionIndex
              ].attrValue = JSON.stringify(cameraPosValue)
              const params = {
                document: {
                  Id: paramsData.documentBaseInfo.id,
                  SiteId: this.currentProject.id,
                  FolderId: paramsData.documentBaseInfo.folderId,
                  ClassId: paramsData.documentBaseInfo.classId,
                  Code: paramsData.documentBaseInfo.code,
                  Name: paramsData.documentBaseInfo.name,
                  PlanDate: paramsData.documentBaseInfo.planDate,
                  ActualDate: paramsData.documentBaseInfo.actualDate,
                  Revision: paramsData.documentBaseInfo.revision,
                  version: paramsData.documentBaseInfo.version,
                  seqNo: paramsData.documentBaseInfo.seqNo,
                },
                generalAttrSet: paramsData.generalAttrSet,
                templateAttrSetList: paramsData.templateAttrSetList,
              }
              const editRes = await DocumentManagementService.editeDocument(params)
              if (editRes && editRes.code === 0) {
                this.$message.success('设置默认打开视角成功！')
              }
            }
          }
        }
      }
    },
    // 切换设置内容
    settingActiveChange(e) {
      if (e.name === 'roamingSetting') {
        document.oncontextmenu = () => {
          return false
        }
        document.onkeydown = (e) => {
          e = window.event || e
          if (
            (e.keyCode >= 112 && e.keyCode <= 123) ||
            e.keyCode === 9 ||
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey
          ) {
            e.preventDefault()
            return false
          }
          return true
        }
      } else {
        document.oncontextmenu = null
        document.onkeydown = null
      }
    },
    // 获取所有设置
    async getAllSetting() {
      const settingJsonData = await this.player.Native.Settings.loadJsonString(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/settings.json`
      )
      let settingsData = {}
      if (settingJsonData) {
        settingsData = JSON.parse(settingJsonData)
      }
      if (settingsData.Show) {
        this.orignDisplaySettings = settingsData.Show
      } else {
        this.orignDisplaySettings = await this.player.Native.Settings.getAll()
      }
      if (settingsData.RoamTrance) {
        this.orignHotKeysSettings = settingsData.RoamTrance
        this.mouseMoveSpeed = settingsData.RoamTrance.RoamingSpeed
      } else {
        this.orignHotKeysSettings = await this.player.Native.Walking.getHotkeys()
        this.mouseMoveSpeed = await this.player.Native.Walking.avatarMoveSpeed()
      }
      if (settingsData.Skin) {
        this.figureSkin = settingsData.Skin
      } else {
        this.figureSkin = {
          avatarCapSkin: 'helmet_white.jpg',
          avatarBodySkin: 'GongRen_red.jpg',
        }
      }
      this.safetyHelmet = this.figureSkin.avatarCapSkin
      this.workingClothes = this.figureSkin.avatarBodySkin
      const playerSettings = _.cloneDeep(this.orignDisplaySettings)
      const roamingSettings = _.cloneDeep(this.orignHotKeysSettings)
      this.setDisplaySettingsValue(playerSettings)
      this.setRoamingSettingsValue(roamingSettings)
      _.forEach(this.orignDisplaySettings, (item) => {
        this.player.Native.Settings.set(item.name, item.type, item.value)
      })
      _.forIn(this.orignHotKeysSettings, (value, key) => {
        const settingKeys = _.reduce(
          value,
          (arr, item) => {
            arr.push(item.split('+'))
            return arr
          },
          []
        )
        this.player.Native.Walking.setHotkey(key, settingKeys)
      })
      const isExists = await this.player.Native.File.exists(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/skin`
      )
      if (isExists) {
        this.player.Native.Walking.setAvatarBodySkin(
          `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${this.figureSkin.avatarBodySkin}`
        )
        this.player.Native.Walking.setAvatarCapSkin(
          `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${this.figureSkin.avatarCapSkin}`
        )
      }
    },
    // 设置页面值
    async setDisplaySettingsValue(data) {
      // 天空盒可选项
      const skyBox = await this.player.Native.Settings.get('skybox.list')
      this.skyBoxOptions = _.map(skyBox.dataSource, (item) => {
        return { value: item, label: item }
      })
      // 点选高亮——bool
      this.pickupHighlight = this.getSettingDetailValue('pickUp.highlight', data)
      // 点选高亮颜色
      this.pickupHighlightColor = this.colorToRgba(this.getSettingDetailValue('pickup.color', data))
      // 包围盒——bool
      this.showSiegeBox = this.getSettingDetailValue('show.select.box', data)
      // 点选轮廓——bool
      this.showPickupOutline = this.getSettingDetailValue('postprocess.outline', data)
      // 点选轮廓颜色
      this.pickupOutlineColor = this.colorToRgba(
        this.getSettingDetailValue('pickup.edgeColor', data),
        true
      )
      // 模型线框——bool
      this.showModelBorder = this.getSettingDetailValue('render.edge', data)
      // 点选背景虚化
      this.pickupBackgroundVirtual = _.toNumber(
        this.getSettingDetailValue('color.pickup.bkAlpha', data).toFixed(2)
      )
      // 摄像机最小裁剪面
      this.minimumVisiblePixel = _.toNumber(this.getSettingDetailValue('MinPixelCount', data))
      this.minimumRotateSpeed = _.toNumber(this.getSettingDetailValue('mouse.rotate.speed', data))
      this.minimumScaleSpeed = _.toNumber(this.getSettingDetailValue('mouse.scale.speed', data))
      // 环境光阻挡——bool
      this.ambientLightBlock = this.getSettingDetailValue('postprocess.ssao', data)
      // 环境光补偿
      this.ambientLightRestitution = _.toNumber(
        this.getSettingDetailValue('ambientIndenty', data).toFixed(2)
      )
      // 全局光源
      this.globalLightSource = this.getSettingDetailValue('context.shaderIndex', data)
      // 全局光源强度
      this.globalLightSourceStrength = _.toNumber(
        this.getSettingDetailValue('diffuseIntensity', data).toFixed(2)
      )
      // 高光强度
      this.highLightStrength = _.toNumber(
        this.getSettingDetailValue('specularIntensity', data).toFixed(2)
      )
      // 摄像机最小裁剪面
      this.minimumCuttingSurface = _.toNumber(
        this.getSettingDetailValue('camera.minClip', data).toFixed(3)
      )
      // 天空盒
      this.skyBox = this.getSettingDetailValue('skybox.list', data)
      // 背面裁剪
      this.backCutting = this.getSettingDetailValue('cullface_mode', data)
      // 锚点信息框——anchorPointInfoFrame
      this.anchorPointInfoFrame = this.getSettingDetailValue('anchorPointInfoFrame', data)
      console.log(data, this.pickupHighlightColor)
    },
    // 获取所有按键设置
    async setRoamingSettingsValue(data) {
      _.forEach(this.shortCutKeySettings, (item) => {
        const keys = _.reduce(
          data[item.name][0].trim().split('+'),
          (arr, el) => {
            const keyInfo = _.find(this.asciiToKeyCode, ['key', el])
            if (keyInfo) {
              arr.push(keyInfo.eventKey)
            }
            return arr
          },
          []
        )
        console.log(keys)
        item.value = keys.join('+')
      })
      console.log(this.shortCutKeySettings)
    },
    // 颜色转换
    colorToRgba(value, special = false) {
      const color = value.split(',')
      if (special) {
        return `rgba(${color[0] * 1},${color[1] * 1},${color[2] * 1},${color[3] * 1})`
      }
      return `rgba(${color[0] * 255},${color[1] * 255},${color[2] * 255},${color[3] * 255})`
    },
    // 查询对应设置值
    getSettingDetailValue(name, data) {
      const settingInfo = _.find(data, ['name', name])
      if (settingInfo) {
        return settingInfo.value
      }
      return ''
    },
    // 漫游按键设置
    keySetting(e, item) {
      let currentKeys = []
      e.target.onkeydown = (event) => {
        console.log(event)
        const keyStatus = _.findIndex(this.asciiToKeyCode, ['code', event.keyCode])
        if (keyStatus === -1) {
          this.$message.warning('按键无效，请重新输入！')
          return
        }
        console.log(event)
        if (_.findIndex(currentKeys, ['code', event.keyCode]) === -1) {
          currentKeys.push(this.asciiToKeyCode[keyStatus])
        }
        item.value = !_.isEmpty(currentKeys) ? _.map(currentKeys, 'eventKey').join('+') : ''
        console.log(item.value)
      }
      e.target.onkeyup = async () => {
        e.srcElement.blur()
        const settingKeys = currentKeys
        console.log(settingKeys)
        if (!_.isEmpty(settingKeys)) {
          const currentSettingKeys = _.reduce(
            settingKeys,
            (arr, el) => {
              const effectKeys = _.find(this.asciiToKeyCode, ['code', el.code])
              if (effectKeys) {
                arr.push(effectKeys.key)
              }
              return arr
            },
            []
          )
          console.log(currentSettingKeys)
          if (!_.isEmpty(currentSettingKeys)) {
            this.player.Native.Walking.setHotkey(item.name, [currentSettingKeys])
          }
        }
        currentKeys = []
      }
    },
    // switch状态改变时触发
    switchChange(e, val) {
      if ((val === 'postprocess.ssao' || val === 'postprocess.outline') && e) {
        this.player.Native.Settings.set('postprocess', 'bool', true)
      }
      this.player.Native.Settings.set(val, 'bool', e)
    },
    // 下拉框选择改变
    selectChange(e, val, type) {
      this.player.Native.Settings.set(val, type, e)
    },
    // 滑动条值改变触发
    sliderChange(e, val, type) {
      if (this.sliderChangeTimerOut) clearTimeout(this.sliderChangeTimerOut)
      this.sliderChangeTimerOut = setTimeout(() => {
        this.player.Native.Settings.set(val, type, e)
      }, 100)
    },
    // 人物移动速度发生变化时
    changeWalkSpeed(e) {
      this.player.Native.Walking.setAvatarMoveSpeed(e)
    },
    // 颜色选择器值改变
    colorPickerChange(e, val, special, type) {
      const rgb = _.map(e.slice(5, -1).split(','), (item) => {
        const res = special ? _.toNumber(item) : _.round(_.toNumber(item) / 255, 2)
        return res
      })
      this.player.Native.Settings.set(val, type, rgb.join(','))
    },
    // 更换人物形象
    async changeFigureMolding(e, name) {
      const isExists = await this.player.Native.File.exists(
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/skin`
      )
      if (isExists) {
        if (name === 'setAvatarBodySkin') {
          const res = await this.player.Native.Walking.setAvatarBodySkin(
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${e}`
          )
          console.log(res)
        } else if (name === 'setAvatarCapSkin') {
          const res = await this.player.Native.Walking.setAvatarCapSkin(
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/skin/${e}`
          )
          console.log(res)
        }
      } else {
        this.$message.warning('暂无人物皮肤')
      }
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../css/index.scss';
#setting {
  width: 368px;
  background-color: rgba(46, 107, 176, 0.5);
  top: 30px;
  right: 35px;
  z-index: 999;
  padding: 10px;
  .close-button {
    right: 5px;
    top: 5px;
    z-index: 999;
  }
  .display-set-card {
    background-color: rgba(24, 41, 72, 0.5) !important;
  }
}
.select-option-item {
  width: 15px;
  height: 15px;
}
.setting-text-lable {
  text-align: right;
  color: #ffffff;
}
/deep/.el-tabs__nav-wrap::after {
  height: 1px !important;
  background-color: #00c0ff;
}
/deep/ .el-tabs__content {
  max-height: 45rem;
  overflow-y: auto;
  .el-tab-pane {
    height: 100%;
  }
}
.color-input /deep/.el-input__inner,
.keystroke-set /deep/.el-input__inner {
  text-align: center;
}
// switch相关
/deep/.el-switch {
  &__core {
    border-color: $danger !important;
    background-color: $danger !important;
  }
}
/deep/ .el-input-number.is-controls-right .el-input__inner {
  padding-right: 30px !important;
}
/deep/.el-switch.is-checked {
  .el-switch__core {
    border-color: $success !important;
    background-color: $success !important;
  }
}
/deep/ .el-input-number.is-controls-right .el-input-number__decrease,
/deep/ .el-input-number.is-controls-right .el-input-number__increase {
  border: none !important;
}

</style>
